import {
  type ISourceEntity,
  ISourceEntityTypes,
  SourceEntityMigrationType,
} from '@principle-theorem/practice-migrations/interfaces';
import { SourceEntity } from '../../../source/source-entity';
import { Timezone, TypeGuard } from '@principle-theorem/shared';
import { isNumber, isString } from 'lodash';
import { BaseSourceEntity } from '../../../source/base-source-entity';

export const PATIENT_MEDICAL_CONDITION_OPTIONS_RESOURCE_TYPE =
  'patientMedicalConditionOptions';

export const PATIENT_MEDICAL_CONDITION_OPTIONS_SOURCE_ENTITY: ISourceEntity =
  SourceEntity.init({
    metadata: {
      label: 'Patient Medical Condition Options',
      description: '',
      idPrefix: PATIENT_MEDICAL_CONDITION_OPTIONS_RESOURCE_TYPE,
      migrationType: SourceEntityMigrationType.Automatic,
    },
  });

export interface ID4WMedicalConditionOption {
  id: number;
  description: string;
}

function isD4WMedicalConditionOption(
  item: unknown,
  logError: boolean
): item is ID4WMedicalConditionOption {
  return TypeGuard.interface<ID4WMedicalConditionOption>(
    {
      id: isNumber,
      description: isString,
    },
    logError
  )(item);
}

const PATIENT_MEDICAL_CONDITION_OPTIONS_SOURCE_QUERY = `
SELECT
  id,
  description,
  convert_to_boolean(is_active) AS is_active
FROM med_conditions
WHERE id IS NOT NULL`;

export type D4WPatientMedicalConditionOptions = ISourceEntityTypes<
  ID4WMedicalConditionOption,
  object,
  object
>;

export class PatientMedicalConditionOptionsSourceEntity extends BaseSourceEntity<D4WPatientMedicalConditionOptions> {
  sourceEntity = PATIENT_MEDICAL_CONDITION_OPTIONS_SOURCE_ENTITY;
  entityResourceType = PATIENT_MEDICAL_CONDITION_OPTIONS_RESOURCE_TYPE;
  sourceQuery = PATIENT_MEDICAL_CONDITION_OPTIONS_SOURCE_QUERY;
  verifySourceFn = isD4WMedicalConditionOption;

  translate(_data: ID4WMedicalConditionOption, _timezone: Timezone): object {
    return {};
  }

  getSourceRecordId(data: ID4WMedicalConditionOption): number {
    return data.id;
  }

  getSourceLabel(record: ID4WMedicalConditionOption): string {
    return `${record.id}-${record.description}`;
  }
}
